import { combineReducers } from "redux";
import merchants from "./merchants";

export default combineReducers({
  merchants,
});
